<template>
    <div class="list">
		<sub-title title="猜你需要"></sub-title>
		
		<div class="list">
			<div class="item" v-for="(item, index) in list" :key="item.goods_id" @click="$router.pushToTab({ path: '/used-detail-' + item.id })">
				<img class="img-wrap" :src="$img(item.thumb)" @error="item.thumb = defaultGoodsImage" />
				<div class="price-wrap">
					<div class="price" v-if="item.price <=0">
						<!-- <p>￥</p> -->
						面议
					</div>
					<div class="price" v-else>
						<p>￥</p>
						{{ item.price }}
					</div>
					<div class="area">
						{{ item.area.name }}
					</div>
					<!-- <div class="market-price">￥{{ item.market_price }}</div> -->
				</div>
				<div class="goods-name">{{ item.title }}</div>
				<div class="shop_name">{{item.site.site_name}}</div>
			</div>
		</div>
		
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
	import {
		usedList,
		newsDetail
	} from "@/api/cms/used";
	import SubTitle from "@/components/SubTitle"
	import DescText from "@/components/DescText"
	
    export default {
        name: "sidebar",
        components: {
			SubTitle,
			DescText
        },
        props: {
            config: {
                type: Object,
                // required: true
            },
			num: {
                type: Number,
                required: true,
				default:4
            },
        },
        data() {
            return {
				list:[],
            }
        },
        created() {
			this.getList()
        },
        computed: {
            ...mapGetters(["defaultGoodsImage"])
        },
        methods: {
            getList(){
            	usedList({
            		// cat_id:15,
            		page_size:this.num
            	}).then(res=>{
            		if (res.code == 0 && res.data) {
            			this.list = res.data.list
            			// this.$set('tabs',this.tabs)
            		}
            	}).catch(err => {
            		this.$message.error(err.message);
            	});
            },
        },
        watch: {
            config: {
                handler: (e)=>{
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>

.list{
	display: flex;
	flex-wrap: wrap;
	
	.item {
		width: 295px;
		margin: 10px 10px 0 0;
		border: 1px solid #eeeeee;
		// padding-top: 10px;
		position: relative;
		padding-bottom: 5px;
		box-sizing: border-box;
		overflow: hidden;
		&:nth-child(4n) {
			margin-right: initial !important;
		}
	
		&:hover {
			border: 1px solid $base-color;
		}
	
		.img-wrap {
			width: 100%;
			height: 198px;
			cursor: pointer;
			padding: 10px;
			box-sizing: border-box;
		}
	
		.goods-name {
			padding: 0 10px;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 1;
			word-break: break-all;
			height: 25px;
			cursor: pointer;
	
			&:hover {
				color: $base-color;
			}
		}
	
		.price-wrap {
			padding: 0 10px;
			display: flex;
			align-items: center;
			
			.price {
				display: flex;
				color: $base-color;
				font-size: $ns-font-size-lg;
	
				p {
					font-size: $ns-font-size-base;
					display: flex;
					align-items: flex-end;
				}
			}
			
			.area {
				flex: 1;
				color: #5f5f5f;
				// text-decoration: line-through;
				margin-right: 0;
				text-align: right;
				
			}
		}
	
		.sale-num {
			padding: 0 10px;
			display: flex;
			color: #838383;
			font-size: $ns-font-size-sm;
	
			p {
				color: #4759a8;
			}
		}
	
		.shop_name {
			padding: 0 10px;
			display: flex;
			color: #838383;
		}
	
		.saling {
			padding: 0 10px;
			display: flex;
			font-size: $ns-font-size-sm;
			line-height: 1;
	
			.free-shipping {
				background: $base-color;
				color: #ffffff;
				padding: 3px 4px;
				border-radius: 2px;
				margin-right: 5px;
			}
	
			.is_own {
				color: #ffffff;
				background: #ff850f;
				border: 1px solid;
				margin-right: 5px;
				display: flex;
				align-items: center;
				padding: 3px 4px;
				border-radius: 2px;
			}
	
			.promotion-type {
				color: $base-color;
				border: 1px solid $base-color;
				display: flex;
				align-items: center;
				padding: 1px 3px;
			}
		}
	
		.item-bottom {
			display: flex;
			margin-top: 5px;
	
			.collection {
				flex: 1;
				border: 1px solid #e9e9e9;
				border-right: none;
				border-left: none;
				height: 40px;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
			}
	
			.cart {
				flex: 2;
				border: 1px solid #e9e9e9;
				border-right: none;
				height: 40px;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
			}
		}
	}
}
</style>
